<template>
  <div class="comments">
    <header class="comments__header">
      <div class="comments__header-content">
        <div class="comments__logo">
          <svg width="23" height="20" viewBox="0 0 23 20" fill="none">
            <path
              d="M6.43154 7.85714C5.64136 7.85714 5.00296 8.49553 5.00296 9.28571C5.00296 10.0759 5.64136 10.7143 6.43154 10.7143C7.22171 10.7143 7.86011 10.0759 7.86011 9.28571C7.86011 8.49553 7.22171 7.85714 6.43154 7.85714ZM11.4315 7.85714C10.6414 7.85714 10.003 8.49553 10.003 9.28571C10.003 10.0759 10.6414 10.7143 11.4315 10.7143C12.2217 10.7143 12.8601 10.0759 12.8601 9.28571C12.8601 8.49553 12.2217 7.85714 11.4315 7.85714ZM16.4315 7.85714C15.6414 7.85714 15.003 8.49553 15.003 9.28571C15.003 10.0759 15.6414 10.7143 16.4315 10.7143C17.2217 10.7143 17.8601 10.0759 17.8601 9.28571C17.8601 8.49553 17.2217 7.85714 16.4315 7.85714ZM11.4315 0C5.11904 0 0.00296287 4.15625 0.00296287 9.28571C0.00296287 11.4107 0.891356 13.3571 2.36457 14.9241C1.69939 16.683 0.315463 18.1741 0.293141 18.192C-0.00150141 18.5045 -0.0818586 18.9598 0.0877843 19.3527C0.257427 19.7455 0.64582 20 1.07439 20C3.81993 20 5.98511 18.8527 7.28421 17.933C8.57439 18.3393 9.96725 18.5714 11.4315 18.5714C17.744 18.5714 22.8601 14.4152 22.8601 9.28571C22.8601 4.15625 17.744 0 11.4315 0ZM11.4315 16.4286C10.2396 16.4286 9.061 16.2455 7.93154 15.8884L6.91814 15.567L6.04761 16.183C5.40921 16.6339 4.53421 17.1384 3.48064 17.4777C3.80653 16.9375 4.1235 16.3304 4.36903 15.683L4.84225 14.4286L3.92261 13.4554C3.11457 12.5938 2.14582 11.1696 2.14582 9.28571C2.14582 5.34821 6.311 2.14286 11.4315 2.14286C16.5521 2.14286 20.7173 5.34821 20.7173 9.28571C20.7173 13.2232 16.5521 16.4286 11.4315 16.4286Z"
              fill="#498388"
            />
          </svg>
        </div>
        <div class="comments__info">
          <h4 class="comments__title">{{ $t("list.comments") }}</h4>
          <span class="comments__subtitle">{{ subtitle }}</span>
        </div>
      </div>
      <button class="comments__close" @click="emit('onClose')">
        <svg
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.143 11.5563L5.90039 7.31371L1.65775 11.5563L0.243536 10.1421L4.48618 5.89949L0.243536 1.65685L1.65775 0.242641L5.90039 4.48528L10.143 0.242641L11.5572 1.65685L7.3146 5.89949L11.5572 10.1421L10.143 11.5563Z"
            fill="#D0E0E0"
          />
        </svg>
      </button>
    </header>
    <div class="comments__content" ref="commentsContainer">
      <div
        v-if="comments?.data"
        v-for="comment in comments.data"
        :key="comment.id"
        class="comment"
        :class="{ 'comment-right': auth.user.id === comment.authorId }"
      >
        <div class="comment__info" v-if="auth.user.id !== comment.authorId">
          <UserImage
            :src="comment.authorImagePath"
            :user="{
              firstName: comment.authorFirstName,
              lastName: comment.authorLastName,
            }"
            width="40"
            height="40"
            background="#FF7366"
          />
          <h5 class="comment__username">
            {{ [comment.authorFirstName, comment.authorLastName].join(" ") }}
          </h5>
        </div>
        <div
          class="comment__message"
          :class="{
            'comment__message-right': auth.user.id === comment.authorId,
          }"
        >
          {{ comment.text }}
        </div>
      </div>
    </div>
    <form
      ref="commentForm"
      class="comments__input"
      @submit.prevent="onAddComment"
    >
        <div class="comments__form-group">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.75093 14.2466H2.97657L10.5274 6.68493L9.3018 5.45753L1.75093 13.0192V14.2466ZM14.27 5.4137L10.5493 1.73151L11.775 0.50411C12.1106 0.168037 12.5229 0 13.012 0C13.5005 0 13.9126 0.168037 14.2482 0.50411L15.4738 1.73151C15.8094 2.06758 15.9845 2.47321 15.9991 2.94838C16.0137 3.42298 15.8532 3.82831 15.5176 4.16438L14.27 5.4137ZM13.0006 6.70685L3.72072 16H0V12.274L9.27991 2.98082L13.0006 6.70685ZM9.91462 6.07123L9.3018 5.45753L10.5274 6.68493L9.91462 6.07123Z"
                  fill="#498388"
                />
              </svg>
              <input
                  type="text"
                  v-model="comment"
                  :placeholder="$t('list.comments_write')"
              />
        </div>
        <button type="submit" class="comments__button">Wyślij</button>
    </form>
  </div>
</template>

<script setup>
import UserImage from "@/components/image/UserImage.vue";
import ApiHelper from "@/helpsers/api.helper";
import authHelper from "@/helpsers/auth.helper";
import { useAuthStore } from "@/stores/auth.store";
import axios from "axios";
import { ref, onMounted, computed } from "vue";
import moment from "moment";
import { useShoppingListStore } from "@/stores/shoppingList.store";

const props = defineProps({
  projectId: {},
  shoppingListId: {},
  roomId: {},
  productId: {},
});
const emit = defineEmits(["onClose"]);
const auth = useAuthStore();
const store = useShoppingListStore();

const commentsContainer = ref(null);
function scrollToBottom() {
  if (commentsContainer.value) {
    commentsContainer.value.scrollTop = commentsContainer.value.scrollHeight;
  }
}

const comments = ref(null);
async function fetchComments() {
  try {
    const res = await axios.get(
      ApiHelper.getProductCommentsUrl(
        props.projectId,
        props.shoppingListId,
        props.roomId,
        props.productId
      ),
      { headers: authHelper.authHeader() }
    );
    comments.value = res.data;
    comments.value.data.reverse();
    store.setProductLastMessageReadByUser(props.productId);
    store.setProductCommentsCount(props.productId, comments.value.data.length);
    setTimeout(() => {
      scrollToBottom();
    }, 0);
  } catch (error) {
    console.error(error);
  }
}
onMounted(() => {
  fetchComments();
});

const subtitle = computed(() => {
  if (!comments.value || comments.value?.data?.length === 0) {
    return "Brak aktywności";
  }
  const lastComment = comments.value.data[comments.value.data.length - 1];
  const message = moment(lastComment.createdAt).locale("pl").fromNow();
  return `Aktywność ${message}`;
});

const comment = ref("");
async function onAddComment() {
  try {
    await axios.post(
      ApiHelper.getProductCommentsUrl(
        props.projectId,
        props.shoppingListId,
        props.roomId,
        props.productId
      ),
      { text: comment.value },
      { headers: authHelper.authHeader() }
    );
    await fetchComments();
    comment.value = "";
  } catch (error) {
    console.error(error);
  }
}
const commentForm = ref();

onMounted(() => {
  const element = commentForm.value;
  element.scrollIntoView({
    block: "end",
  });
});
</script>
<style scoped lang="scss">
.comments {
  position: absolute;
  bottom: 0;
  left: 0;
  transform: translateY(100%);
  width: 100%;
  background-color: #fff;
  z-index: 30;
  border-radius: 0 0 30px 30px;
  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #3b767b;
    padding: 11px 15px;
    color: #fff;
  }
  &__header-content {
    display: flex;
    gap: 10px;
  }
  &__logo {
    width: 42px;
    height: 42px;
    background-color: #e4eded;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &__info {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 2px 0;
  }
  &__title {
    font-size: 2.25rem;
    font-weight: 600;
  }
  &__subtitle {
    font-size: 1.5rem;
    font-weight: 500;
  }
  &__close {
    border: none;
    width: 34px;
    height: 34px;
    border-radius: 50%;
    background-color: #498388;
    display: flex;
    justify-content: center;
    align-items: center;
    &:hover {
      cursor: pointer;
      opacity: 0.8;
    }
  }
  &__content {
    height: 360px;
    overflow-y: auto;
    padding: 24px;
    display: flex;
    flex-direction: column;
  }
  &__input {
    background: #e4eded;
    border: 1px solid #c5d8d8;
    border-radius: 0 0 30px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    height: 60px;
    input {
      border: none;
      outline: none;
      background-color: transparent;
      font-family: "Montserrat";
      font-weight: 500;
      font-size: 1.875rem;

      color: #498388;
      width: 100%;
      &::placeholder {
        font-family: "Montserrat";
        font-weight: 500;
        font-size: 1.875rem;
        color: #87aeb1;
      }
    }
  }

    &__form-group {
        display: flex;
        gap: 1rem;
        margin-left: 10px;
        flex-grow: 10;
        align-items: center;
    }

  &__button {
        height: 100%;
        width: auto;
        background-color: #3b767b;
        border: none;
        color: white;
        border-radius: 0 0 30px 0;
        cursor: pointer;
        outline: none;
        flex-grow: 1;

      &:hover {
          background-color: #c5d8d8;
          color: black;
          outline: 1px solid #3b767b;;
      }

    }
}
.comment {
  max-width: 60%;
  width: max-content;
  margin-top: 12px;
  &:nth-of-type(1) {
    margin-top: 0;
  }
  &-right {
    align-self: flex-end;
    margin-top: 5px;
  }
  &__info {
    display: flex;
    align-items: center;
    gap: 2rem;
  }
  &__username {
    font-size: 1.75rem;
    font-weight: 600;
  }
  &__message {
    //margin-left: calc(40px + 2rem);
    background: rgba(173, 111, 105, 0.1);
    border-radius: 0px 10px 10px 10px;
    padding: 12px 18px;
    color: #6f6d6d;
    font-size: 1.75rem;
    font-weight: 500;
    margin-left: 55px;
    width: fit-content;
      @media screen and (max-width: 500px) {
          margin-left: 0px;
          margin-top: 5px;
      }

    &-right {
      background-color: #498388;
      color: #f4f8f8;
      border-radius: 10px 10px 0px 10px;
    }
  }
}
</style>
